import { env } from "@config/env";
import { logger } from "@/shared/utils/logger";
import WebApp from "@twa-dev/sdk";

export const handleCopyShareBotLink = async (
  refcode: string,
  isMiniApp: boolean
) => {
  if (!refcode) return;

  const link = isMiniApp
    ? `https://t.me/${env.botUsername}?start=${refcode}`
    : `${window.location.origin}/?refcode=${refcode}`;

  try {
    try {
      await navigator.clipboard.writeText(link);
    } catch (err) {
      try {
        const textarea = document.createElement("textarea");
        textarea.value = link;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();

        document.execCommand("copy");
        document.body.removeChild(textarea);
      } catch (error) {
        logger.error("Copy fallback failed:", error);
      }
    }

    if (isMiniApp) {
      WebApp.openTelegramLink(
        `https://t.me/share/url?url=${encodeURIComponent(link)}`
      );
      return true;
    }

    if (navigator.share) {
      await navigator.share({ url: link });
    } else {
      window.prompt("Copy to clipboard: Ctrl+C, Enter", link);
    }

    return true;
  } catch (error) {
    logger.error("Share error:", error);
    return false;
  }
};
